import { themeColors } from './colors'
import { createTheme } from '@mui/material/styles'
import { plPL, enUS } from '@mui/material/locale'

export const createAppTheme = (language?: string) =>
  createTheme(
    {
      typography: {
        fontFamily: "'Montserrat', sans-serif",
      },
      palette: {
        primary: {
          main: themeColors.primary,
        },
        secondary: {
          main: themeColors.secondary,
        },
        error: {
          main: themeColors.error,
        },
      },
      components: {
        MuiTab: {
          styleOverrides: {
            root: {
              color: themeColors.gray,
              fontWeight: 600,
              selected: {
                color: themeColors.primary,
              },
            },
          },
        },
      },
    },
    language === 'pl' ? plPL : enUS,
  )

